import { removeTimezone } from "@hopper-b2b/utilities";
import dayjs from "dayjs";

/**
 * Parse a flight segment date/time string into a `Date` that carries the
 * airport-local wall clock.
 *
 * Backend segment times (`scheduledDeparture`, `zonedScheduledDeparture`, etc.)
 * include a timezone offset — e.g. `"2026-08-24T10:00:00.000+10:00"` or the
 * Scala `LocalDateTime` form `"2026-08-24T10:00-04:00[America/Toronto]"`.
 * Feeding those directly into `new Date(...)` / `dayjs(...)` produces an absolute
 * instant that `formatDateTime` then renders in the *browser's* timezone,
 * shifting a Sydney flight into Vancouver time and rolling the calendar day
 * back (see RBC "My Trips" timezone bug).
 *
 * `removeTimezone` strips the offset so the wall clock is preserved and the
 * segment always displays in its own airport-local time regardless of the
 * viewer's timezone.
 *
 * @param time an ISO-ish segment date/time string, optionally offset-bearing
 * @returns a `Date` at the airport-local wall clock (Invalid Date if `time` is
 *   empty/undefined — callers already guard on `isNaN(date.getTime())`)
 */
export const parseSegmentLocalDate = (time?: string): Date =>
  // Guard against `dayjs(undefined)`, which returns the current date/time.
  time ? dayjs(removeTimezone(time)).toDate() : new Date(NaN);
